import Button from "components/components/Button/Button";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  display: inline-block;
  width: 180px;
  &&&.date-filter {
    margin: 0 0 2px 0;
  }
`;
